function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(function () {
    let headerBounds = {};
    let currentScrollTop = 0;
    const stickyElements = document.querySelectorAll('[data-sticky="true"]');
    createObserver();
    window.addEventListener('scroll', onScroll, false);

    function createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(stickyElements[0]);
    }

    function onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom) {
            requestAnimationFrame(hide.bind(this));
        } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom) {
            requestAnimationFrame(reveal.bind(this));
        } else if (scrollTop <= headerBounds.top) {
            requestAnimationFrame(reset.bind(this));
        }

        currentScrollTop = scrollTop;
    }

    function hide() {
        for (const sticky of stickyElements) {
            sticky.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        }
    }

    function reveal() {
        for (const sticky of stickyElements) {
            sticky.classList.add('shopify-section-header-sticky', 'animate');
            sticky.classList.remove('shopify-section-header-hidden');
        }
    }

    function reset() {
        for (const sticky of stickyElements) {
            sticky.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
    }
});
